import { gate } from 'hub-http/gates';
export const gates = {
  HUBSPOT_CREDITS: gate('HubSpotCredits'),
  ENRICHMENT_INCLUDED: gate('DataEnrichment:Included')
};